import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { XlsxService } from './../../../../shared/xlsx/xlsx.service';
import { NotificationServiceService } from './../../../../../../services/notification-service/notification-service.service';
import { ContenedoresService } from './../../../../../../services/API/contenedores/contenedores.service';
import { NewMantenimientoComponent } from './../components/mantenimientos/new-mantenimiento/new-mantenimiento.component';
import { EditMantenimientoComponent } from './../components/mantenimientos/edit-mantenimiento/edit-mantenimiento.component'; 
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatSort, Sort } from '@angular/material/sort';
import { AuthService } from './../../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-view-mantenimintos',
    templateUrl: './view-mantenimintos.component.html',
    styleUrls: ['./view-mantenimintos.component.css'],
    standalone: false
})
export class ViewMantenimintosComponent implements OnInit {

  @Input() contenedorID: any = 'all';
  showProgressBar: boolean = true;
  displayedColumns = ['id', 'matricula', 'fechaAlta', 'fechaAccion', 'coste', 'tipo', 'estado'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  tipo: string = 'all'; 
  active: string = 'all';

  constructor(private xlsxService: XlsxService, private dialog: MatDialog, private notificationService: NotificationServiceService, private contenedoresService: ContenedoresService, public authService: AuthService) { }

  ngOnInit(): void {
    this.prepareTable();
    this.getMantenimientos();
  }

  getMantenimientos() {
    this.showProgressBar = true;
    this.contenedoresService.getMantenimientosContenedores(this.contenedorID, this.tipo, this.active).subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newMantenimiento() {
    const newNivelDialog = this.dialog.open(NewMantenimientoComponent, {
      data: {'contenedor': this.contenedorID},
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result === 'save'){
        this.getMantenimientos();
      }
    });
  }

  editarMantenimiento(id: number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["idMantenimiento"] === id){
        console.log(this.dataSource1[i]);
        const modifDialog = this.dialog.open(EditMantenimientoComponent, {
          data: {'mantenimiento': id, 'contenedor' : this.dataSource1[i]["idContenedor"], 'tipo' : this.dataSource1[i]["tipo"], 'fechaAlta' : this.dataSource1[i]["fechaAlta"], 'fechaAccion' : this.dataSource1[i]["fechaAccion"], 'coste' : this.dataSource1[i]["coste"], 'observaciones' : this.dataSource1[i]["observaciones"], 'estado' : this.dataSource1[i]["estado"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result === 'save'){
            this.getMantenimientos();
          }
        });
        break;
      }
    }
  }

  deleteMantenimiento(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar mantenimiento', body: '¿Seguro que deseas eliminar este mantenimiento?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.contenedoresService.deleteMantenimiento(id).subscribe(() => {
          this.notificationService.openSnackBar("Mantenimiento eliminado correctamente!");
          this.showProgressBar = false;
          this.getMantenimientos();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Mantenimientos por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch(property) {
        case 'fecha': return this.convertirFecha(item[property]);
        case 'coste': return parseFloat(item[property]);
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      'Matricula': item['matricula'],
      'Fecha alta': item['fechaAlta'],
      'Fecha acción': item['fechaAccion'],
      'Coste': item['coste'],
      'Tipo': item['tipo'],
      'Estado': item['estado'],
      'Observaciones': item['observaciones'],
    }));
    this.xlsxService.saveExcelData(excelData, 'Mantenimientos');
  }

  convertirFecha(cadena: any) {
    const partes = cadena.split(' ');
  
    // Fecha
    const fechaPartes = partes[0].split('-');
    const dia = parseInt(fechaPartes[0], 10);
    const mes = parseInt(fechaPartes[1], 10) - 1; // Los meses en JavaScript comienzan en 0
    const anio = parseInt(fechaPartes[2], 10);
  
    /* Hora
    const horaPartes = partes[1].split(':');
    const horas = parseInt(horaPartes[0], 10);
    const minutos = parseInt(horaPartes[1], 10);*/
  
    const fecha = new Date(anio, mes, dia); // , horas, minutos
    return fecha;
  }

  canAltaMantenimiento(): boolean {
    return this.authService.canAltaMantenimiento();
  }

  canManageContenedores(): boolean {
    return this.authService.hasFullContenedoresAccess();
  }

}
 